import { Reveal } from "@/lib/motion";
import { Search, ClipboardList, PenTool, Code2, Rocket, BarChart3, TrendingUp } from "lucide-react";

const STEPS = [
  { icon: Search, title: "Discover", desc: "We learn about your business, goals and challenges." },
  { icon: ClipboardList, title: "Analyze", desc: "We audit your website and digital presence in detail." },
  { icon: PenTool, title: "Plan", desc: "We create a custom strategy and website blueprint." },
  { icon: Code2, title: "Build", desc: "We design, develop and integrate powerful features." },
  { icon: Rocket, title: "Launch", desc: "We test, optimize and launch your new website." },
  { icon: BarChart3, title: "Measure", desc: "We track performance and uncover growth opportunities." },
  { icon: TrendingUp, title: "Grow", desc: "We continuously improve to help your business grow." },
];

export default function Process() {
  return (
    <section className="relative z-10 py-20 md:py-28 bg-slate-50 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <span className="overline">Our Process</span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-slate-900 tracking-tight mt-3">
            A Proven Process for Digital Success
          </h2>
        </Reveal>

        <div className="relative mt-16">
          <div className="hidden lg:block absolute top-8 left-[7%] right-[7%] h-px border-t-2 border-dashed border-slate-300" />
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-y-10 gap-x-4">
            {STEPS.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.07}>
                <div className="relative flex flex-col items-center text-center" data-testid={`process-${i}`}>
                  <div className="relative w-16 h-16 rounded-full bg-white border-2 border-slate-200 flex items-center justify-center text-brand soft-shadow">
                    <s.icon size={24} />
                    <span className="absolute -top-1.5 -right-1.5 w-6 h-6 rounded-full bg-brand text-white text-[11px] font-mono font-bold flex items-center justify-center">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="font-heading font-bold text-slate-900 mt-4">{s.title}</h3>
                  <p className="text-slate-500 text-xs mt-1.5 leading-relaxed max-w-[140px]">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
